import * as React from "react";
import {
  Box,
  Card,
  CardContent,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";

/**
 * A skeleton loader for the Tenants page
 * This displays placeholder elements with animations while the real data is loading
 */
export const TenantsSkeleton: React.FC = () => {
  return (
    <Box sx={{ p: 1, ml: 2, mr: 2, height: "100%" }}>
      <Stack direction="column" spacing={2} sx={{ height: "100%" }}>
        {/* Title and Add button skeleton */}
        <Stack direction="row" justifyContent="space-between" sx={{ mt: 2 }}>
          <Skeleton variant="text" width={400} height={40} />
          <Skeleton variant="rounded" width={150} height={40} />
        </Stack>

        {/* Search field and filters skeleton */}
        <Stack direction="row" spacing={1}>
          {/* Search field */}
          <Skeleton 
            variant="rectangular" 
            width="100%" 
            height={56} 
            sx={{ borderRadius: 1 }}
          />

          {/* Filter dropdowns */}
          <Stack direction="row" spacing={1} justifyContent="flex-start">
            <Stack direction="row" alignItems="center">
              <Skeleton 
                variant="rectangular" 
                width={240} 
                height={56} 
                sx={{ borderRadius: 1 }}
              />
              <Skeleton variant="circular" width={40} height={40} />
            </Stack>
            <Stack direction="row" alignItems="center">
              <Skeleton 
                variant="rectangular" 
                width={240} 
                height={56} 
                sx={{ borderRadius: 1 }}
              />
              <Skeleton variant="circular" width={40} height={40} />
            </Stack>
          </Stack>
        </Stack>

        {/* DataGrid skeleton */}
        <Skeleton 
          variant="rectangular" 
          height="calc(100vh - 200px)" 
          width="100%" 
          sx={{ 
            minHeight: 400,
            animation: "pulse 1.5s ease-in-out 0.5s infinite",
            borderRadius: 1
          }}
        />

        {/* Skeleton rows to simulate data */}
        <Box sx={{ display: "none" }}>
          {[...Array(5)].map((_, index) => (
            <Stack 
              key={index}
              direction="row" 
              spacing={2} 
              sx={{ mt: 1 }}
            >
              <Skeleton variant="text" width={120} height={30} />
              <Skeleton variant="text" width={150} height={30} />
              <Skeleton variant="text" width={180} height={30} />
              <Skeleton variant="text" width={120} height={30} />
              <Skeleton variant="text" width={150} height={30} />
              <Skeleton variant="text" width={175} height={30} />
              <Skeleton variant="text" width={250} height={30} />
            </Stack>
          ))}
        </Box>
      </Stack>
    </Box>
  );
};
